import React from "react";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";


const ConfirmModal:React.FC<propTypes> = (props:propTypes) => {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 991) {
      setFlag(true);
    }
  }, []);

  return (
    <Modal show={props.show} onHide={props.onHide} id="modal" centered={flag === true} data-testid="ConfirmModal">
        <Modal.Header closeButton>
            <Modal.Title>
                <h5 className="modal-title" id="staticBackdropLabel">Confirmation</h5>
              </Modal.Title>
          </Modal.Header>
        <Modal.Body>
            <div>{props.message}</div>
        </Modal.Body>
        <Modal.Footer>
            <button type="button" className="btn btn-secondary" data-testid="CancelBtn" onClick={props.onHide}>Cancel</button>
            <button type="button" onClick={props.confirm} data-testid="ConfirmBtn" className="btn btn-primary">Confirm</button>
          </Modal.Footer>
    </Modal>
  );
}

type propTypes = {
  message: string,
  onHide: () => void,
  confirm: () => void,
  id: string,
  show: boolean
};

export default ConfirmModal;